module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal animated is-active"
  }, [_c('div', {
    staticClass: "modal-background"
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-card is-large"
  }, [_c('header', {
    staticClass: "modal-card-head"
  }, [_c('p', {
    staticClass: "modal-card-title"
  }, [_vm._v(_vm._s(_vm.title))])]), _vm._v(" "), _c('section', {
    staticClass: "modal-card-body"
  }, [(_vm.error !== '') ? _c('div', {
    staticClass: "notification is-danger"
  }, [_vm._v(_vm._s(_vm.error))]) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.base.name),
      expression: "base.name"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'input': true,
      'is-danger': _vm.errors.has('name'),
      'is-disabled': _vm.inProgress
    },
    attrs: {
      "type": "text",
      "name": "name",
      "id": "name",
      "placeholder": "Name"
    },
    domProps: {
      "value": (_vm.base.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.base, "name", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('name')),
      expression: "errors.has('name')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('name')))])]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Email")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.base.email),
      expression: "base.email"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|email'),
      expression: "'required|email'"
    }],
    class: {
      'input': true,
      'is-danger': _vm.errors.has('email'),
      'is-disabled': _vm.inProgress
    },
    attrs: {
      "type": "email",
      "name": "email",
      "id": "email",
      "placeholder": "Email"
    },
    domProps: {
      "value": (_vm.base.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.base, "email", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('email')),
      expression: "errors.has('email')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('email')))])]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Social Reason")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.base.social_reason),
      expression: "base.social_reason"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'input': true,
      'is-danger': _vm.errors.has('social_reason'),
      'is-disabled': _vm.inProgress
    },
    attrs: {
      "type": "text",
      "name": "social_reason",
      "id": "social_reason",
      "placeholder": "Social Reason"
    },
    domProps: {
      "value": (_vm.base.social_reason)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.base, "social_reason", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('social_reason')),
      expression: "errors.has('social_reason')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('social_reason')))])]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("CNPJ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.base.cnpj),
      expression: "base.cnpj"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|numeric'),
      expression: "'required|numeric'"
    }],
    class: {
      'input': true,
      'is-danger': _vm.errors.has('cnpj'),
      'is-disabled': _vm.inProgress
    },
    attrs: {
      "type": "text",
      "name": "cnpj",
      "id": "cnpj",
      "placeholder": "CNPJ"
    },
    domProps: {
      "value": (_vm.base.cnpj)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.base, "cnpj", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('cnpj')),
      expression: "errors.has('cnpj')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('cnpj')))])]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Municipal Inscription")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.base.municipal_inscription),
      expression: "base.municipal_inscription"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('numeric'),
      expression: "'numeric'"
    }],
    class: {
      'input': true,
      'is-danger': _vm.errors.has('municipal_inscription'),
      'is-disabled': _vm.inProgress
    },
    attrs: {
      "type": "text",
      "name": "municipal_inscription",
      "id": "municipal_inscription",
      "placeholder": "Municipal Inscription"
    },
    domProps: {
      "value": (_vm.base.municipal_inscription)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.base, "municipal_inscription", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('municipal_inscription')),
      expression: "errors.has('municipal_inscription')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('municipal_inscription')))])]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (parseInt(_vm.context.$store.state.config.user.level) < 4),
      expression: "parseInt(context.$store.state.config.user.level) < 4"
    }],
    staticClass: "control"
  }, [_c('label', {
    staticClass: "checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.base.nf),
      expression: "base.nf"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.base.nf) ? _vm._i(_vm.base.nf, null) > -1 : (_vm.base.nf)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.base.nf,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.base, "nf", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.base, "nf", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.base, "nf", $$c)
        }
      }
    }
  }), _vm._v("\n          NFS-e\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "control is-vertical"
  }, [_c('div', {
    staticClass: "control is-grouped"
  }, [_c('p', {
    staticClass: "control is-expanded"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Phone")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.base.phone),
      expression: "base.phone"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'input': true,
      'is-danger': _vm.errors.has('phone'),
      'is-disabled': _vm.inProgress
    },
    attrs: {
      "type": "text",
      "name": "phone",
      "id": "phone",
      "placeholder": "Phone"
    },
    domProps: {
      "value": (_vm.base.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.base, "phone", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('phone')),
      expression: "errors.has('phone')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('phone')))])]), _vm._v(" "), _c('p', {
    staticClass: "control is-expanded"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Emergency Phone")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.base.emergency_phone),
      expression: "base.emergency_phone"
    }],
    class: {
      'input': true,
      'is-danger': _vm.errors.has('emergency_phone'),
      'is-disabled': _vm.inProgress
    },
    attrs: {
      "type": "text",
      "name": "emergency_phone",
      "id": "emergency_phone",
      "placeholder": "Emergency Phone"
    },
    domProps: {
      "value": (_vm.base.emergency_phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.base, "emergency_phone", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('emergency_phone')),
      expression: "errors.has('emergency_phone')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('emergency_phone')))])])])]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("CEP")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.base.cep),
      expression: "base.cep"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|numeric'),
      expression: "'required|numeric'"
    }],
    class: {
      'input': true,
      'is-danger': _vm.errors.has('cep'),
      'is-disabled': _vm.inProgress
    },
    attrs: {
      "type": "cep",
      "name": "cep",
      "id": "cep",
      "placeholder": "CEP"
    },
    domProps: {
      "value": (_vm.base.cep)
    },
    on: {
      "change": _vm.cep,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.base, "cep", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('cep')),
      expression: "errors.has('cep')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('cep')))])]), _vm._v(" "), _c('div', {
    staticClass: "control is-vertical"
  }, [_c('div', {
    staticClass: "control is-grouped"
  }, [_c('p', {
    staticClass: "control is-expanded"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Address")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.base.address),
      expression: "base.address"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'input': true,
      'is-danger': _vm.errors.has('address'),
      'is-disabled': _vm.inProgress || _vm.cepProgress
    },
    attrs: {
      "type": "text",
      "name": "address",
      "id": "address",
      "placeholder": "Address"
    },
    domProps: {
      "value": (_vm.base.address)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.base, "address", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('address')),
      expression: "errors.has('address')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('address')))])]), _vm._v(" "), _c('p', {
    staticClass: "control is-expanded"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Address Number")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.base.address_number),
      expression: "base.address_number"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|numeric'),
      expression: "'required|numeric'"
    }],
    class: {
      'input': true,
      'is-danger': _vm.errors.has('address_number'),
      'is-disabled': _vm.inProgress || _vm.cepProgress
    },
    attrs: {
      "type": "text",
      "name": "address_number",
      "id": "address_number",
      "placeholder": "Address Number"
    },
    domProps: {
      "value": (_vm.base.address_number)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.base, "address_number", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('address_number')),
      expression: "errors.has('address_number')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('address_number')))])]), _vm._v(" "), _c('p', {
    staticClass: "control is-expanded"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Neighborhood")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.base.address_neighborhood),
      expression: "base.address_neighborhood"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'input': true,
      'is-danger': _vm.errors.has('address_neighborhood'),
      'is-disabled': _vm.inProgress || _vm.cepProgress
    },
    attrs: {
      "type": "text",
      "name": "address_neighborhood",
      "id": "address_neighborhood",
      "placeholder": "Neighborhood"
    },
    domProps: {
      "value": (_vm.base.address_neighborhood)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.base, "address_neighborhood", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('address_neighborhood')),
      expression: "errors.has('address_neighborhood')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('address_neighborhood')))])])])]), _vm._v(" "), _c('p', {
    staticClass: "control is-expanded"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Address Complement")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.base.address_complement),
      expression: "base.address_complement"
    }],
    class: {
      'input': true,
      'is-danger': _vm.errors.has('address_complement'),
      'is-disabled': _vm.inProgress
    },
    attrs: {
      "type": "text",
      "name": "address_complement",
      "id": "address_complement",
      "placeholder": "Address Complement"
    },
    domProps: {
      "value": (_vm.base.address_complement)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.base, "address_complement", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('address_complement')),
      expression: "errors.has('address_complement')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('address_complement')))])]), _vm._v(" "), _c('div', {
    staticClass: "control is-vertical"
  }, [_c('div', {
    staticClass: "control is-grouped"
  }, [_c('p', {
    staticClass: "control is-expanded"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("City")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.base.city),
      expression: "base.city"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'input': true,
      'is-danger': _vm.errors.has('city'),
      'is-disabled': _vm.inProgress || _vm.cepProgress
    },
    attrs: {
      "type": "text",
      "name": "city",
      "id": "city",
      "placeholder": "City"
    },
    domProps: {
      "value": (_vm.base.city)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.base, "city", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('city')),
      expression: "errors.has('city')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('city')))])]), _vm._v(" "), _c('p', {
    staticClass: "control is-expanded"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("IBGE")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.base.cmun),
      expression: "base.cmun"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: (_vm.base.nf ? 'required' : ''),
      expression: "base.nf ? 'required' : ''"
    }],
    class: {
      'input': true,
      'is-danger': _vm.errors.has('cmun'),
      'is-disabled': _vm.inProgress || _vm.cepProgress
    },
    attrs: {
      "type": "text",
      "name": "cmun",
      "id": "cmun",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.base.cmun)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.base, "cmun", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('cmun')),
      expression: "errors.has('cmun')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('cmun')))])]), _vm._v(" "), _c('p', {
    staticClass: "control is-expanded"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("State")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.base.state),
      expression: "base.state"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'input': true,
      'is-danger': _vm.errors.has('state'),
      'is-disabled': _vm.inProgress || _vm.cepProgress
    },
    attrs: {
      "type": "text",
      "name": "state",
      "id": "state",
      "placeholder": "State"
    },
    domProps: {
      "value": (_vm.base.state)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.base, "state", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('state')),
      expression: "errors.has('state')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('state')))])]), _vm._v(" "), _c('p', {
    staticClass: "control is-expanded"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Country")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.base.country),
      expression: "base.country"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'input': true,
      'is-danger': _vm.errors.has('country'),
      'is-disabled': _vm.inProgress || _vm.cepProgress
    },
    attrs: {
      "type": "text",
      "name": "country",
      "id": "country",
      "placeholder": "Country"
    },
    domProps: {
      "value": (_vm.base.country)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.base, "country", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('country')),
      expression: "errors.has('country')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('country')))])])])]), _vm._v(" "), _c('p', {
    class: {
      'control': true
    }
  }, [_vm._m(0), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.base.emails_invoice),
      expression: "base.emails_invoice"
    }],
    class: {
      'textarea': true,
      'is-danger': _vm.errors.has('emails_invoice')
    },
    attrs: {
      "name": "emails_invoice",
      "id": "emails_invoice",
      "placeholder": "E-mails"
    },
    domProps: {
      "value": (_vm.base.emails_invoice)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.base, "emails_invoice", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('emails_invoice')),
      expression: "errors.has('emails_invoice')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('emails_invoice')))])]), _vm._v(" "), _c('p', {
    class: {
      'control': true
    }
  }, [_vm._m(1), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.base.emails_reconfirmation),
      expression: "base.emails_reconfirmation"
    }],
    class: {
      'textarea': true,
      'is-danger': _vm.errors.has('emails_reconfirmation')
    },
    attrs: {
      "name": "emails_reconfirmation",
      "id": "emails_reconfirmation",
      "placeholder": "E-mails"
    },
    domProps: {
      "value": (_vm.base.emails_reconfirmation)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.base, "emails_reconfirmation", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('emails_reconfirmation')),
      expression: "errors.has('emails_reconfirmation')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('emails_reconfirmation')))])]), _vm._v(" "), _c('p', {
    class: {
      'control': true
    }
  }, [_vm._m(2), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.base.emails_notification),
      expression: "base.emails_notification"
    }],
    class: {
      'textarea': true,
      'is-danger': _vm.errors.has('emails_notification')
    },
    attrs: {
      "name": "emails_notification",
      "id": "emails_notification",
      "placeholder": "E-mails"
    },
    domProps: {
      "value": (_vm.base.emails_notification)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.base, "emails_notification", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('emails_notification')),
      expression: "errors.has('emails_notification')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('emails_notification')))])]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('label', {
    staticClass: "checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.base.operator),
      expression: "base.operator"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.base.operator) ? _vm._i(_vm.base.operator, null) > -1 : (_vm.base.operator)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.base.operator,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.base, "operator", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.base, "operator", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.base, "operator", $$c)
        }
      }
    }
  }), _vm._v("\n          Operator\n        ")])]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('label', {
    staticClass: "checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.base.invoicable),
      expression: "base.invoicable"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.base.invoicable) ? _vm._i(_vm.base.invoicable, null) > -1 : (_vm.base.invoicable)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.base.invoicable,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.base, "invoicable", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.base, "invoicable", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.base, "invoicable", $$c)
        }
      }
    }
  }), _vm._v("\n          Invoicable\n        ")])]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('label', {
    staticClass: "checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.base.is_markup),
      expression: "base.is_markup"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.base.is_markup) ? _vm._i(_vm.base.is_markup, null) > -1 : (_vm.base.is_markup)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.base.is_markup,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.base, "is_markup", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.base, "is_markup", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.base, "is_markup", $$c)
        }
      }
    }
  }), _vm._v("\n          Markup\n        ")])]), _vm._v(" "), _c('p', {
    staticClass: "control is-expanded"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Markup")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.base.markup),
      expression: "base.markup"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|decimal'),
      expression: "'required|decimal'"
    }],
    class: {
      'input': true,
      'is-danger': _vm.errors.has('net_price')
    },
    attrs: {
      "name": "markup",
      "id": "markup",
      "type": "text",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.base.markup)
    },
    on: {
      "focusout": function($event) {
        return _vm.backi('markup')
      },
      "focusin": function($event) {
        return _vm.cleani('markup')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.base, "markup", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('markup')),
      expression: "errors.has('markup')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('markup')))])]), _vm._v(" "), _c('p', {
    staticClass: "control is-expanded"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Booking Fee")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.base.bf),
      expression: "base.bf"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|decimal'),
      expression: "'required|decimal'"
    }],
    class: {
      'input': true,
      'is-danger': _vm.errors.has('bf')
    },
    attrs: {
      "type": "text",
      "placeholder": "",
      "name": "bf",
      "id": "bf"
    },
    domProps: {
      "value": (_vm.base.bf)
    },
    on: {
      "focusout": function($event) {
        return _vm.backi('bf')
      },
      "focusin": function($event) {
        return _vm.cleani('bf')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.base, "bf", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('bf')),
      expression: "errors.has('bf')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('bf')))])])]), _vm._v(" "), _c('footer', {
    staticClass: "modal-card-foot"
  }, [_c('div', {
    staticClass: "control is-grouped is-pulled-right"
  }, [_c('p', {
    staticClass: "control is-pulled-right"
  }, [_c('a', {
    class: {
      'button': true,
      'is-primary': true,
      'is-disabled': _vm.inProgress
    },
    on: {
      "click": function($event) {
        return _vm.close(true)
      }
    }
  }, [_vm._v("Close")])]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('a', {
    class: {
      'button': true,
      'is-success': true,
      'is-disabled': _vm.errors.any() || _vm.cepLoading,
      'is-loading': _vm.inProgress
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("Save")])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "label"
  }, [_vm._v("E-mails Invoice\n          "), _c('small', [_vm._v("Ex: separate like (support@agency.com; contact@agency.com)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "label"
  }, [_vm._v("E-mails Reconfirmation\n          "), _c('small', [_vm._v("Ex: separate like (support@agency.com; contact@agency.com)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "label"
  }, [_vm._v("E-mails Notification\n          "), _c('small', [_vm._v("Ex: separate like (support@agency.com; contact@agency.com)")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6973c982","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/bases/Base.vue
// module id = 1151
// module chunks = 39